"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureStatusEnum = void 0;
exports.instanceOfFeatureStatusEnum = instanceOfFeatureStatusEnum;
exports.FeatureStatusEnumFromJSON = FeatureStatusEnumFromJSON;
exports.FeatureStatusEnumFromJSONTyped = FeatureStatusEnumFromJSONTyped;
exports.FeatureStatusEnumToJSON = FeatureStatusEnumToJSON;
exports.FeatureStatusEnumToJSONTyped = FeatureStatusEnumToJSONTyped;
/**
 * * `HU` - Hidden Utility
 * * `PU` - Public Utility
 * * `H` - Helper
 * * `C` - Contextual
 * * `S` - Standalone
 * @export
 * @enum {string}
 */
var FeatureStatusEnum;
(function (FeatureStatusEnum) {
    FeatureStatusEnum["Hu"] = "HU";
    FeatureStatusEnum["Pu"] = "PU";
    FeatureStatusEnum["H"] = "H";
    FeatureStatusEnum["C"] = "C";
    FeatureStatusEnum["S"] = "S";
})(FeatureStatusEnum || (exports.FeatureStatusEnum = FeatureStatusEnum = {}));
function instanceOfFeatureStatusEnum(value) {
    for (const key in FeatureStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(FeatureStatusEnum, key)) {
            if (FeatureStatusEnum[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function FeatureStatusEnumFromJSON(json) {
    return FeatureStatusEnumFromJSONTyped(json, false);
}
function FeatureStatusEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function FeatureStatusEnumToJSON(value) {
    return value;
}
function FeatureStatusEnumToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=featureStatusEnum.js.map